import React from 'react';
import type { ComponentProps } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { lineHeight } from 'styled-system';

import { MessageType } from '../enums/Alert';
import { Flex } from './Flex';

const getColors = ({ type, theme }) => {
  switch (type) {
    case MessageType.Success:
      return [theme.colors.sys.success.background.weak, theme.colors.sys.success.background.hover];
    case MessageType.Warning:
      return [theme.colors.sys.warning.background.weak, theme.colors.sys.warning.background.hover];
    case MessageType.Error:
      return [theme.colors.sys.error.background.weak, theme.colors.sys.error.text.default];
    default:
      return [];
  }
};

const UnstyledBanner = styled(Flex)<any>`
  ${props => {
    const [backgroundColor, color] = getColors(props);

    return css`
      background-color: ${backgroundColor};
      color: ${color};
    `;
  }};
  ${lineHeight};
`;

const Banner = (props: ComponentProps<typeof UnstyledBanner>) => (
  <UnstyledBanner display="flex" alignItems="center" justifyContent="center" py="sp_8" {...props} />
);

export default Banner;
